// extracted by mini-css-extract-plugin
export var button = "contacts-module--button--96daa";
export var cardTitle = "contacts-module--cardTitle--3d7ea";
export var firstSectionContainer = "contacts-module--firstSectionContainer--9b61f";
export var heading = "contacts-module--heading--68f17";
export var s2CardContainer = "contacts-module--s2CardContainer--19781";
export var sectionContainer = "contacts-module--sectionContainer--d0ef2";
export var titleMobile = "contacts-module--titleMobile--47f50";